// QuizDiagnostics.js - Fixed for client components
import React, { useState } from "react";
import stringSimilarity from "string-similarity";
import "./QuizDiagnostics.css";

const QuizDiagnostics = ({ askedQuestions, isDuplicateQuizQuestion }) => {
  const [testQuestion, setTestQuestion] = useState("");
  const [diagnosticResults, setDiagnosticResults] = useState(null);

  const runDiagnostic = () => {
    if (!testQuestion.trim()) {
      alert("Please enter a test question");
      return;
    }

    // Check if the question would be considered a duplicate
    const isDuplicate = isDuplicateQuizQuestion(testQuestion);

    // Find similar questions
    const similarQuestions = askedQuestions
      .map(q => {
        const questionText = typeof q === 'string' ? q : (q.text || q.question || "");
        if (!questionText || typeof questionText !== 'string') return null;

        const similarity = stringSimilarity.compareTwoStrings(
          testQuestion.toLowerCase(),
          questionText.toLowerCase()
        );

        return {
          question: questionText,
          similarity: similarity,
          timestamp: q.timestamp ? new Date(q.timestamp).toLocaleString() : 'Unknown'
        };
      })
      .filter(item => item !== null && item.similarity > 0.3) // Show questions with at least some similarity
      .sort((a, b) => b.similarity - a.similarity); // Sort by similarity (highest first)

    setDiagnosticResults({
      isDuplicate,
      similarQuestions
    });
  };

  const clearDiagnostics = () => {
    setTestQuestion("");
    setDiagnosticResults(null);
  };

  return (
    <div className="diagnostics-panel">
      <h3>Quiz Diagnostics</h3>
      <div className="diagnostic-form">
        <textarea
          placeholder="Enter a test question to check for duplicates..."
          value={testQuestion}
          onChange={(e) => setTestQuestion(e.target.value)}
          rows={3}
          className="diagnostic-input"
        />
        <div className="diagnostic-buttons">
          <button onClick={runDiagnostic} className="diagnostic-run-button">
            Check Question
          </button>
          <button onClick={clearDiagnostics} className="diagnostic-clear-button">
            Clear
          </button>
        </div>
      </div>

      {diagnosticResults && (
        <div className="diagnostic-results">
          <div className={`diagnostic-result ${diagnosticResults.isDuplicate ? 'duplicate' : 'unique'}`}>
            This question would be considered:
            <strong>{diagnosticResults.isDuplicate ? ' DUPLICATE' : ' UNIQUE'}</strong>
          </div>

          {diagnosticResults.similarQuestions.length > 0 ? (
            <>
              <h4>Similar Questions:</h4>
              <ul className="similar-questions-list">
                {diagnosticResults.similarQuestions.map((item, index) => {
                  // Determine similarity class for styling
                  let similarityClass = "";
                  if (item.similarity >= 0.8) similarityClass = "high";
                  else if (item.similarity >= 0.5) similarityClass = "medium";
                  else similarityClass = "low";

                  return (
                    <li key={index} className="similar-question-item">
                      <div className="similar-question-text">{item.question}</div>
                      <div className="similar-question-meta">
                        <span className={`similarity-score ${similarityClass}`}>
                          Similarity: {(item.similarity * 100).toFixed(1)}%
                        </span>
                        <span className="timestamp">{item.timestamp}</span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </>
          ) : (
            <p>No similar questions found in history.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizDiagnostics;